import z from 'zod/v4';
import { SubtitleFilterSchema } from './subtitleSchema.js';
// Audio Actions - discriminated union on `type`
export const AudioActionByLanguageSchema = z.object({
    type: z.literal('by_language'),
    languages: z.array(z.string()).min(1),
    preferChannels: z.enum(['most', 'least']).optional(),
});
export const AudioActionByTitleSchema = z.object({
    type: z.literal('by_title'),
    titleContains: z.string().min(1),
});
export const AudioActionDefaultSchema = z.object({
    type: z.literal('default'),
});
export const AudioActionSchema = z.discriminatedUnion('type', [
    AudioActionByLanguageSchema,
    AudioActionByTitleSchema,
    AudioActionDefaultSchema,
]);
// Subtitle Actions - discriminated union on `type`
export const SubtitleActionDisableSchema = z.object({
    type: z.literal('disable'),
});
export const SubtitleActionByLanguageSchema = z.object({
    type: z.literal('by_language'),
    languages: z.array(z.string()).min(1),
    filterType: SubtitleFilterSchema.default('any'),
    allowImageBased: z.boolean().default(true),
    allowExternal: z.boolean().default(true),
});
export const SubtitleActionDefaultSchema = z.object({
    type: z.literal('default'),
});
export const SubtitleActionSchema = z.discriminatedUnion('type', [
    SubtitleActionDisableSchema,
    SubtitleActionByLanguageSchema,
    SubtitleActionDefaultSchema,
]);
// Stream Selection Rule
export const StreamSelectionRuleSchema = z.object({
    label: z.string().optional(),
    condition: z.string().min(1),
    audioAction: AudioActionSchema,
    subtitleAction: SubtitleActionSchema,
});
// Stream Selection Profile
export const StreamSelectionProfileSchema = z.object({
    uuid: z.string(),
    name: z.string().min(1),
    rules: z.array(StreamSelectionRuleSchema).min(1),
});
// Create/Update request schemas (no uuid required)
export const CreateStreamSelectionProfileSchema = z.object({
    name: z.string().min(1),
    rules: z.array(StreamSelectionRuleSchema).min(1),
});
export const UpdateStreamSelectionProfileSchema = CreateStreamSelectionProfileSchema;
//# sourceMappingURL=streamSelectionSchema.js.map